import { VehicleBuyInSignatureDevice, VehicleBuyInStatus, VehicleBuyInType } from "@/api-schema-enums";
import type { VehicleBuyInSearchBody } from "@/common/api/vehicle-buy-in/use-vehicle-buy-in-search.query";
import { inputStringToDate } from "@/common/helpers/date-input";
import { formatDateToApi } from "@/common/helpers/format-date";
import { DateFormat } from "@/store/user-config-store";

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

function toIsoDateOrUndefined(value: string | undefined, dateFormat: DateFormat): string | undefined {
  if (!value) return undefined;
  if (ISO_DATE_REGEX.test(value)) return value;

  const parsedDate = inputStringToDate(value, { dateFormat });
  return parsedDate ? formatDateToApi(parsedDate) : undefined;
}

export function buildVehicleBuyInSearchBody({
  filterValues,
  dateFormat,
}: {
  filterValues: Record<string, string[]>;
  dateFormat: DateFormat;
}): VehicleBuyInSearchBody {
  const createdAtFrom = toIsoDateOrUndefined(filterValues.createdAt?.[0], dateFormat);
  const createdAtTo = toIsoDateOrUndefined(filterValues.createdAt?.[1], dateFormat);

  return {
    ...(filterValues.status?.length > 0 && { status: filterValues.status as VehicleBuyInStatus[] }),
    ...(filterValues.type?.length > 0 && { type: filterValues.type as VehicleBuyInType[] }),
    ...(filterValues.signatureDevice?.length > 0 && {
      signatureDevice: filterValues.signatureDevice as VehicleBuyInSignatureDevice[],
    }),
    ...(filterValues.companyGroup?.length > 0 && { companyGroup: filterValues.companyGroup }),
    ...(filterValues.company?.length > 0 && { company: filterValues.company }),
    ...(filterValues.branch?.length > 0 && { branch: filterValues.branch }),
    ...(filterValues.createdBy?.length > 0 && { createdBy: filterValues.createdBy }),
    ...(createdAtFrom && { createdAtFrom }),
    ...(createdAtTo && { createdAtTo }),
  };
}
